import { createContext } from 'react'

const PresentationContext = createContext(null)

export default PresentationContext
